function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, String, activeItem, busy, controller, creating, disableCreateDashboard, multiselect, newTitle, open, searchFilter, sections, selectionChanges) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['searchable-text'] = function(value, placeholder, searchTokens) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((!value) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("i", [__vjadeSafeCode(placeholder)]));;
          return __jade_nodes
        }).call(this)) : (searchTokens) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = (searchTokens);
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, token, pos) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((pos % 2 === 1) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(token);;
                    return __jade_nodes
                  }).call(this)) : ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("b", [__vjadeSafeCode(token)]));;
                    return __jade_nodes
                  }).call(this)));;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var pos = $$objKey;
                  if ($$obj.hasOwnProperty(pos)) {
                    $$iterated = true;
                    var token = $$obj[pos];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((pos % 2 === 1) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(token);;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("b", [__vjadeSafeCode(token)]));;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })());;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(value);;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("mp-drop-menu", {
        "attrs": __vjadeStringifyAttrsIfObj({
          open
        }),
        "on": {
          change: $helpers.handleMenuChange
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-dashboard-selector-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-dashboard-selector-search-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-input", {
              "attrs": __vjadeStringifyAttrsIfObj({
                icon: `search`,
                placeholder: `Search dashboards...`,
              }),
              "on": {
                input: $helpers.handleSearchInput
              },
              "props": {
                value: searchFilter
              },
              "hook": {
                insert: $helpers.handleSearchInputInsertHook
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((!(controller && controller.getLoaded())) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-dashboard-selector-loading': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-dashboard-selector-items-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((sections.length === 0) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-dashboard-selector-empty-state': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(searchFilter ? `No dashboards found.` : `You do not have any dashboards yet.`);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (sections);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, section, sectionIndex) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((sectionIndex !== 0) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-dashboard-selector-divider': true
                            },
                          }));;
                          return __jade_nodes
                        }).call(this)) : undefined);
                        __jade_nodes = __jade_nodes.concat(h("section", (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-dashboard-selector-section-header': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(section.title);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat((function() {
                            var $$obj = (section.items);
                            var $$eachNodes;
                            var $$iterated = false;
                            if (Array.isArray($$obj)) {
                              $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                                $$iterated = true;
                                return $$eachNodes.concat((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'mp-dashboard-selector-item-row-wrapper': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(($helpers.getCheckDisabled(item) && multiselect) ? ((function() {
                                      var __jade_nodes = [];
                                      const tooltipTextMissingAccess = $helpers.isSharingEnabled() ? `editor` : `edit`;;
                                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                        "attrs": __vjadeStringifyAttrsIfObj({
                                          placement: `top`
                                        }),
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(`You don't have ${tooltipTextMissingAccess} access on this dashboard`);;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this)) : undefined);
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "key": item.dashboard.id,
                                      "on": {
                                        click: $helpers.getItemActionHandler(item),
                                        mouseover: $helpers.getItemMouseOverHandler(item),
                                      },
                                      "hook": {
                                        insert: $helpers.handleItemRowInsertHook
                                      },
                                      "class": Object.assign({}, {
                                        'mp-dashboard-selector-active': activeItem && (activeItem.dashboard.id === item.dashboard.id),
                                        'mp-dashboard-selector-disabled': $helpers.getCheckDisabled(item),
                                      }, {
                                        'mp-dashboard-selector-item-row': true
                                      }),
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat((multiselect) ? ((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "class": Object.assign({}, {
                                            'mp-dashboard-selector-checked': $helpers.getChecked(item)
                                          }, {
                                            'mp-dashboard-selector-checkbox': true
                                          }),
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                            "attrs": __vjadeStringifyAttrsIfObj({
                                              icon: `checkmark`
                                            }),
                                          }));;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this)) : undefined);
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'mp-dashboard-selector-text': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "class": Object.assign({}, {
                                            'mp-dashboard-selector-placeholder': !item.dashboard.title
                                          }, {
                                            'mp-dashboard-selector-title': true
                                          }),
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(jade_mixins['searchable-text'].call(this, item.dashboard.title, `Untitled dashboard`, item.titleSearchTokens));;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "class": Object.assign({}, {
                                            'mp-dashboard-selector-placeholder': !item.dashboard.description
                                          }, {
                                            'mp-dashboard-selector-description': true
                                          }),
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(jade_mixins['searchable-text'].call(this, item.dashboard.description, `No description`, item.descriptionSearchTokens));;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this));
                              }, []);
                            } else {
                              $$eachNodes = [];
                              for (var $$objKey in $$obj) {
                                (function() {
                                  var $index = $$objKey;
                                  if ($$obj.hasOwnProperty($index)) {
                                    $$iterated = true;
                                    var item = $$obj[$index];
                                    $$eachNodes = $$eachNodes.concat((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'mp-dashboard-selector-item-row-wrapper': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(($helpers.getCheckDisabled(item) && multiselect) ? ((function() {
                                          var __jade_nodes = [];
                                          const tooltipTextMissingAccess = $helpers.isSharingEnabled() ? `editor` : `edit`;;
                                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                            "attrs": __vjadeStringifyAttrsIfObj({
                                              placement: `top`
                                            }),
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(`You don't have ${tooltipTextMissingAccess} access on this dashboard`);;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this)) : undefined);
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "key": item.dashboard.id,
                                          "on": {
                                            click: $helpers.getItemActionHandler(item),
                                            mouseover: $helpers.getItemMouseOverHandler(item),
                                          },
                                          "hook": {
                                            insert: $helpers.handleItemRowInsertHook
                                          },
                                          "class": Object.assign({}, {
                                            'mp-dashboard-selector-active': activeItem && (activeItem.dashboard.id === item.dashboard.id),
                                            'mp-dashboard-selector-disabled': $helpers.getCheckDisabled(item),
                                          }, {
                                            'mp-dashboard-selector-item-row': true
                                          }),
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat((multiselect) ? ((function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "class": Object.assign({}, {
                                                'mp-dashboard-selector-checked': $helpers.getChecked(item)
                                              }, {
                                                'mp-dashboard-selector-checkbox': true
                                              }),
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                                "attrs": __vjadeStringifyAttrsIfObj({
                                                  icon: `checkmark`
                                                }),
                                              }));;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this)) : undefined);
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "class": {
                                              'mp-dashboard-selector-text': true
                                            },
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "class": Object.assign({}, {
                                                'mp-dashboard-selector-placeholder': !item.dashboard.title
                                              }, {
                                                'mp-dashboard-selector-title': true
                                              }),
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(jade_mixins['searchable-text'].call(this, item.dashboard.title, `Untitled dashboard`, item.titleSearchTokens));;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "class": Object.assign({}, {
                                                'mp-dashboard-selector-placeholder': !item.dashboard.description
                                              }, {
                                                'mp-dashboard-selector-description': true
                                              }),
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(jade_mixins['searchable-text'].call(this, item.dashboard.description, `No description`, item.descriptionSearchTokens));;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this));
                                  }
                                })();
                              }
                            }

                            return $$eachNodes;
                          })());;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var sectionIndex = $$objKey;
                        if ($$obj.hasOwnProperty(sectionIndex)) {
                          $$iterated = true;
                          var section = $$obj[sectionIndex];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((sectionIndex !== 0) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'mp-dashboard-selector-divider': true
                                },
                              }));;
                              return __jade_nodes
                            }).call(this)) : undefined);
                            __jade_nodes = __jade_nodes.concat(h("section", (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'mp-dashboard-selector-section-header': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(section.title);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));
                              __jade_nodes = __jade_nodes.concat((function() {
                                var $$obj = (section.items);
                                var $$eachNodes;
                                var $$iterated = false;
                                if (Array.isArray($$obj)) {
                                  $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                                    $$iterated = true;
                                    return $$eachNodes.concat((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'mp-dashboard-selector-item-row-wrapper': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(($helpers.getCheckDisabled(item) && multiselect) ? ((function() {
                                          var __jade_nodes = [];
                                          const tooltipTextMissingAccess = $helpers.isSharingEnabled() ? `editor` : `edit`;;
                                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                            "attrs": __vjadeStringifyAttrsIfObj({
                                              placement: `top`
                                            }),
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(`You don't have ${tooltipTextMissingAccess} access on this dashboard`);;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this)) : undefined);
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "key": item.dashboard.id,
                                          "on": {
                                            click: $helpers.getItemActionHandler(item),
                                            mouseover: $helpers.getItemMouseOverHandler(item),
                                          },
                                          "hook": {
                                            insert: $helpers.handleItemRowInsertHook
                                          },
                                          "class": Object.assign({}, {
                                            'mp-dashboard-selector-active': activeItem && (activeItem.dashboard.id === item.dashboard.id),
                                            'mp-dashboard-selector-disabled': $helpers.getCheckDisabled(item),
                                          }, {
                                            'mp-dashboard-selector-item-row': true
                                          }),
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat((multiselect) ? ((function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "class": Object.assign({}, {
                                                'mp-dashboard-selector-checked': $helpers.getChecked(item)
                                              }, {
                                                'mp-dashboard-selector-checkbox': true
                                              }),
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                                "attrs": __vjadeStringifyAttrsIfObj({
                                                  icon: `checkmark`
                                                }),
                                              }));;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this)) : undefined);
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "class": {
                                              'mp-dashboard-selector-text': true
                                            },
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "class": Object.assign({}, {
                                                'mp-dashboard-selector-placeholder': !item.dashboard.title
                                              }, {
                                                'mp-dashboard-selector-title': true
                                              }),
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(jade_mixins['searchable-text'].call(this, item.dashboard.title, `Untitled dashboard`, item.titleSearchTokens));;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "class": Object.assign({}, {
                                                'mp-dashboard-selector-placeholder': !item.dashboard.description
                                              }, {
                                                'mp-dashboard-selector-description': true
                                              }),
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(jade_mixins['searchable-text'].call(this, item.dashboard.description, `No description`, item.descriptionSearchTokens));;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this));
                                  }, []);
                                } else {
                                  $$eachNodes = [];
                                  for (var $$objKey in $$obj) {
                                    (function() {
                                      var $index = $$objKey;
                                      if ($$obj.hasOwnProperty($index)) {
                                        $$iterated = true;
                                        var item = $$obj[$index];
                                        $$eachNodes = $$eachNodes.concat((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "class": {
                                              'mp-dashboard-selector-item-row-wrapper': true
                                            },
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(($helpers.getCheckDisabled(item) && multiselect) ? ((function() {
                                              var __jade_nodes = [];
                                              const tooltipTextMissingAccess = $helpers.isSharingEnabled() ? `editor` : `edit`;;
                                              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                                "attrs": __vjadeStringifyAttrsIfObj({
                                                  placement: `top`
                                                }),
                                              }, (function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(`You don't have ${tooltipTextMissingAccess} access on this dashboard`);;
                                                return __jade_nodes
                                              }).call(this).filter(Boolean)));;
                                              return __jade_nodes
                                            }).call(this)) : undefined);
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "key": item.dashboard.id,
                                              "on": {
                                                click: $helpers.getItemActionHandler(item),
                                                mouseover: $helpers.getItemMouseOverHandler(item),
                                              },
                                              "hook": {
                                                insert: $helpers.handleItemRowInsertHook
                                              },
                                              "class": Object.assign({}, {
                                                'mp-dashboard-selector-active': activeItem && (activeItem.dashboard.id === item.dashboard.id),
                                                'mp-dashboard-selector-disabled': $helpers.getCheckDisabled(item),
                                              }, {
                                                'mp-dashboard-selector-item-row': true
                                              }),
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat((multiselect) ? ((function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                  "class": Object.assign({}, {
                                                    'mp-dashboard-selector-checked': $helpers.getChecked(item)
                                                  }, {
                                                    'mp-dashboard-selector-checkbox': true
                                                  }),
                                                }, (function() {
                                                  var __jade_nodes = [];
                                                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                                    "attrs": __vjadeStringifyAttrsIfObj({
                                                      icon: `checkmark`
                                                    }),
                                                  }));;
                                                  return __jade_nodes
                                                }).call(this).filter(Boolean)));;
                                                return __jade_nodes
                                              }).call(this)) : undefined);
                                              __jade_nodes = __jade_nodes.concat(h("div", {
                                                "class": {
                                                  'mp-dashboard-selector-text': true
                                                },
                                              }, (function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                  "class": Object.assign({}, {
                                                    'mp-dashboard-selector-placeholder': !item.dashboard.title
                                                  }, {
                                                    'mp-dashboard-selector-title': true
                                                  }),
                                                }, (function() {
                                                  var __jade_nodes = [];
                                                  __jade_nodes = __jade_nodes.concat(jade_mixins['searchable-text'].call(this, item.dashboard.title, `Untitled dashboard`, item.titleSearchTokens));;
                                                  return __jade_nodes
                                                }).call(this).filter(Boolean)));
                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                  "class": Object.assign({}, {
                                                    'mp-dashboard-selector-placeholder': !item.dashboard.description
                                                  }, {
                                                    'mp-dashboard-selector-description': true
                                                  }),
                                                }, (function() {
                                                  var __jade_nodes = [];
                                                  __jade_nodes = __jade_nodes.concat(jade_mixins['searchable-text'].call(this, item.dashboard.description, `No description`, item.descriptionSearchTokens));;
                                                  return __jade_nodes
                                                }).call(this).filter(Boolean)));;
                                                return __jade_nodes
                                              }).call(this).filter(Boolean)));;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this));
                                      }
                                    })();
                                  }
                                }

                                return $$eachNodes;
                              })());;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat((busy) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-dashboard-selector-busy': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : (creating) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-dashboard-selector-create-field': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-input-group", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    placeholder: `New dashboard title`,
                    busy
                  }),
                  "on": {
                    input: $helpers.handleCreateInput,
                    submit: $helpers.handleCreateSubmit,
                  },
                  "props": {
                    value: newTitle
                  },
                  "hook": {
                    insert: $helpers.handleCreateInputInsertHook
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : (multiselect && (selectionChanges.size > 0)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
                "on": {
                  click: $helpers.handleApplyClick
                },
                "class": {
                  'mp-button-bar-secondary': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Add");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : (!disableCreateDashboard) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
                "on": {
                  click: $helpers.handleCreateClick
                },
                "class": {
                  'mp-button-bar-secondary': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Create New Dashboard");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : ($attr(`enable-management`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
                "on": {
                  click: $helpers.handleManageClick
                },
                "class": {
                  'mp-button-bar-secondary': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Manage Dashboards");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "activeItem" in locals ? locals.activeItem : typeof activeItem !== "undefined" ? activeItem : undefined, "busy" in locals ? locals.busy : typeof busy !== "undefined" ? busy : undefined, "controller" in locals ? locals.controller : typeof controller !== "undefined" ? controller : undefined, "creating" in locals ? locals.creating : typeof creating !== "undefined" ? creating : undefined, "disableCreateDashboard" in locals ? locals.disableCreateDashboard : typeof disableCreateDashboard !== "undefined" ? disableCreateDashboard : undefined, "multiselect" in locals ? locals.multiselect : typeof multiselect !== "undefined" ? multiselect : undefined, "newTitle" in locals ? locals.newTitle : typeof newTitle !== "undefined" ? newTitle : undefined, "open" in locals ? locals.open : typeof open !== "undefined" ? open : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "sections" in locals ? locals.sections : typeof sections !== "undefined" ? sections : undefined, "selectionChanges" in locals ? locals.selectionChanges : typeof selectionChanges !== "undefined" ? selectionChanges : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;